export default __webpack_public_path__ + "static/media/opened-blue.5ffca99b.svg";